<template>
    <span>{{ count }}</span>
</template>

<script>
    export default {
        computed: {
            count() {
                return this.$store.getters.getPropertiesFavorites ? this.$store.getters.getPropertiesFavorites.length : 0
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/FavoritesCounter.vue